<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.75 4H6.25C5.00736 4 4 5.00736 4 6.25V13.75C4 14.9926 5.00736 16 6.25 16H13.75C14.9926 16 16 14.9926 16 13.75V6.25C16 5.00736 14.9926 4 13.75 4Z"
    fill="var(--iconPrimary, #292929)" />
</svg>